export function addBucketIfRequired(defaultBucket, id) {
    return id && id.id
        ? id
        : { bucket: defaultBucket, id: id };
}
//# sourceMappingURL=pointer.js.map